import { Injectable } from '@angular/core';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class PKCEEncoderService {

  constructor() { }

  encode(str) {
    return btoa(str)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
  }
}
